<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher, onMount} from "svelte";
    import type {IFechaItem} from "../../interfaces/fecha-item.interface";

    export let data: IFechaItem;
    export let isDisabled: boolean = false;
    let dispatch = new createEventDispatcher();

    function clickItem(slug) {
        dispatch('edit', slug);
    }
    let min = '';

    onMount(()=>{
        const now = new Date();
        const day = now.getDate() < 10 ? `0${now.getDate()}`: `${now.getDate()}`;
        const month = (now.getMonth() + 1) < 10 ? `0${now.getMonth() + 1}`: `${now.getMonth() + 1}`;
        min = `${now.getFullYear()}-${month}-${day}`;
    });

</script>
<tr>
    <td>
        <div class="py-1">{data.label}</div>
    </td>
    <td>
        <div class="py-1 pr-2">
            <input class="naui-input"
                   {min}
                   type="date"
                   readonly={isDisabled}
                   bind:value={data.date}>
        </div>
    </td>
    <td>
        <div>
            <div class="py-1">
                {#each data.items as person (person.id)}
                    <div class="w-max-content mb-ii">
                        {person.name} | {person.role?.initials || person.role?.name}
                    </div>
                {/each}
            </div>
        </div>
    </td>
    <td>
        <div class="py-1 pr-15">
            <div class="self-start">
                {#if !isDisabled}
                    <NauiButton icon="pencil"
                                color="accent"
                                on:click={clickItem.bind(this,data.slug)}/>
                {/if}
            </div>
        </div>
    </td>
</tr>
<style>
    td {
        vertical-align: top;
    }
</style>